import { useTranslation } from "react-i18next";
import { useRegistration } from "./useRegistration";
import { AutoSave } from "../../../commonjs/components/Autosave";
import { Form, Field } from "react-final-form";
import { RenderField } from "../../../commonjs/components";

export const PartNumbers = () => {
  const { t } = useTranslation();
  const { setPartNumbers } = useRegistration();

  const validatePartNumbers = ({ part_numbers }) => {
    let errors = {};

    if (part_numbers && (part_numbers.length < 6 || part_numbers.length > 250)) {
      errors.part_numbers = t(
        "Provide part numbers or explanation (6 - 250 characters)"
      );
    }

    return errors;
  };

  return (
    <div>
      <div className="grid__item xs-12 vertical-spacing">
        <h3>{t("Stellantis Part Numbers")}</h3>
      </div>
      <div className="grid__item xs-12">
        <Form
          // not using submit functionality, data is handled with AutoSave
          onSubmit={() => {}}
          validate={validatePartNumbers}
        >
          {() => (
            <div>
              <AutoSave
                onValid={(values) => {
                  setPartNumbers(values.part_numbers);
                }}
                onInvalid={(values) => {
                  setPartNumbers(undefined);
                }}
              />
              <Field
                name="part_numbers"
                component={RenderField}
                type="text"
                placeholder={t(
                  "Type in 1 to 3 part numbers and, if you do not know any, then explain why"
                )}
              />
            </div>
          )}
        </Form>
      </div>
    </div>
  );
};
